export default function Impresszum() {
  return (
    <div className="container my-5">
      <h1 className="mb-4">Impresszum</h1>
      <p className="mb-3">Hatályos: 2025. december 18.</p>
      <p>
        A <strong>Financials.hu</strong> weboldal üzemeltetője a{" "}
        <strong>Smart Financials.hu Kft.</strong>
      </p>
      <p className="mb-5">
        Székhely: 2014 Csobánka, Kilátó utca 4. <br />
        Cégjegyzékszám: 01-09-982832 <br />
        Adószám: 24725736-2-41 <br />
        E-mail: financials@financials.hu
      </p>

      <p>
        A weboldalon megjelenő tartalmak – ideértve szövegeket, képeket,
        videókat, grafikákat és egyéb médiaelemeket –{" "}
        <strong>minden joga a Smart Financials.hu Kft.-t illeti</strong>, azok
        engedély nélküli felhasználása, másolása vagy közzététele tilos. Az
        oldal tartalma kizárólag a weboldal üzemeltetője által engedélyezett
        formában használható.
      </p>

      <p className="mb-3">
        A weboldalon megjelenő információk hitelességére a Smart Financials.hu
        Kft. maximális szakmai gondossággal törekszik. Mindazonáltal a tartalmak
        pontosságát befolyásolhatják a külső források változásai, ezért a
        weboldalon szereplő információk felhasználásából eredő esetleges
        károkért a cég felelősséget nem vállal.
      </p>

      <p className="my-5 py-3">
        A weboldal használata során a felhasználók személyes adatait a Smart
        Financials.hu Kft. a hatályos adatvédelmi előírásoknak megfelelően
        kezeli. Az adatkezelésről részletes tájékoztatást az{" "}
        <a className="anchor" href="/adatkezelesi-tajekoztato">
          adatvédelmi nyilatkozat
        </a>{" "}
        tartalmaz.
      </p>

      <p className="mt-5">
        Engedélykérések és tartalomátvételi kérelmek esetén kérjük, lépjen
        velünk kapcsolatba a{" "}
        <a className="anchor" href="mailto:financials@financials.hu">
          financials@financials.hu
        </a>{" "}
        email címen.
      </p>
    </div>
  );
}
